import React from 'react'
import { withTranslation } from 'react-i18next'
import AddListItemButton from '../../../Controls/AddListItemButton'
import Result from '../components/Result'

const ResultList = ({ tmpStructure, validationStructure, tabsValidationResult, methods, pages, t }) => (
    <>
        {tmpStructure.results.length ? (
            <ul className={`list${!methods.canDo('add', 'r') ? ' is-full' : ''}`}>
                {tmpStructure.results.map((result, rIndex) => {
                    return (
                        <Result
                            pages={pages}
                            key={rIndex}
                            result={result}
                            validationStructure={validationStructure}
                            tmpStructure={tmpStructure}
                            tabsValidationResult={tabsValidationResult}
                            methods={methods}
                            rIndex={rIndex}
                        />
                    )
                })}
            </ul>
        ) : null}
        {methods.canDo('add', 'results') ? (
            <AddListItemButton
                title={t('Add result')}
                length={tmpStructure.results.length}
                onClick={() => methods.onAdd('results')}
            />
        ) : null}
    </>
)

export default withTranslation()(ResultList)
